import * as yup from 'yup';

import { FiscalAccountType } from '@blockpulse3/graphql/hooks';
import { requiredSelectField, requiredStringField } from '@blockpulse3/web-client/forms';

import { IFiscalAccountForm } from './types';

export const fiscalAccountSchema = yup.object({
  type: requiredSelectField,
  accountNumber: requiredStringField,
  bankName: requiredStringField,
  bankCode: requiredStringField,
  bankEmail: yup.string().email().notRequired(),
}) as yup.ObjectSchema<IFiscalAccountForm>;

export const fiscalAccountDefaults: IFiscalAccountForm = {
  type: { label: 'PEA', value: FiscalAccountType.PEA },
  accountNumber: '',
  bankName: '',
  bankCode: '',
  bankEmail: '',
};
